
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {
  HqPackingList,
  CustomsPackingSet,
  UnpackedProductInfos,
} from "@/model/inventory-plan";
import {deleteInventoryPlans} from "@/api/inventory-plan";
import {isEmpty, toUpper} from "lodash";
import {LoadingPlanType} from "@/views/sales-management/SalesBookingOrderManagement.vue";
import ProductTable from "./ProductTable.vue";

/**
 * 盘库详情
 */
@Component({
  name: "ConfirmTable",
  components: {
    ProductTable,
  },
})
export default class extends Vue {
  @Prop({required: true}) private data: HqPackingList;
  @Prop({required: false, default: false}) private useInvoiceMoney: boolean;
  @Prop({required: false, default: false}) private idsList: [];
  @Prop({required: false, default: false}) private checkedAll: boolean;
  @Prop({required: false, default: "1"}) private confirmType: string;
  private data_: HqPackingList;
  private options: HqPackingList;
  private showEdit = false;
  private currentRow: CustomsPackingSet = new CustomsPackingSet();
  selection: CustomsPackingSet[] = [];

  @Watch("data", {deep: true, immediate: true})
  private watchData() {
    this.data_ = this.data;
  }

  @Watch("idsList", {deep: true, immediate: true})
  @Watch("checkedAll", {deep: true, immediate: true})
  private watchCheckedAll() {
    if (!this.checkedAll) {
      this.toggleSelection([]);
    }
    this.toggleSelection(this.data_.customsPackingSet);
  }

  private checkSelectable(row: CustomsPackingSet) {
    return !row.inventoryState || row.inventoryState.name === "TO_BE_INVENTORY";
  }

  private toggleSelection(rows: CustomsPackingSet[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          (
              this.$refs.multipleTable as Vue & { toggleRowSelection: Function }
          ).toggleRowSelection(row);
        });
      });
    } else {
      this.$nextTick(() => {
        (
            this.$refs.multipleTable as Vue & { clearSelection: Function }
        ).clearSelection();
      });
    }
  }

  private confirmEdit(row: UnpackedProductInfos) {
    this.$emit("edit-product-number", row);
  }

  private handleSelectionChange(rows: CustomsPackingSet[]) {
    this.selection = rows;
  }

  private gotoPackageManagementPage() {
    this.$emit("gotoPackageManagementPage", this.data_.id);
  }

  // 删除盘库
  private handleDelete(rows: CustomsPackingSet) {
    this.$confirm("Confirm to remove the item?", "Warning", {
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      type: "warning",
    }).then(() => {
      this.sureDelete(rows);
    });
  }

  private async sureDelete(rows: CustomsPackingSet) {
    await deleteInventoryPlans(rows.id);
    this.$message({
      type: "success",
      message: "Deleted!",
    });
  }

  private handleEditPackageInfo(rows: CustomsPackingSet) {
    this.currentRow = rows;
    this.showEdit = true;
  }

  private async onDialogConfirmed() {
    this.showEdit = false;
    this.$emit("onDialogConfirmed", this.currentRow);
  }

  private checkProblemCustomsPackingImage(customsPackingId: string) {
    this.$emit("close");
    this.$router.push({
      name: "ImageManagement",
      params: {
        bizType: "customs-packing",
        objectId: customsPackingId,
      },
    });
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
